import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Tab, Icon, Modal } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { Button } from 'semantic-ui-react'
import { ProcurementContainer, ProcurementBody } from '../../styled'
import { billFormPath, billCoverPath } from 'routes'
import RequestInformation from './RequestInformation'
import BillInformation from './BillInformation'
import CommentHistory from './CommentHistory'
import Attachment from './Attachment'
import Approve from './Approve'
import Contract from './Contract'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { getBillformDetail, initializeBL, getBLGOAWorkFlowViewMode, clearBLDetail } from 'ducks/billform'
import { haveTypeGoods } from '../billingHelper'

// import r from 'reactotron-react-js'

const BillingDetail = (props) => {
  const { history, blDetail, valueForm, approvers, match: { params }, isDetail = true, } = props

  const [showWarningPOUpdate, setShowWarningPOUpdate] = React.useState(false)

  React.useEffect(() => {
    props.initializeBL(isDetail)
    if (params && params.blId) {
      props.getBillformDetail(params.blId, history, false)
    }
    return (() => {
      props.clearBLDetail()
    })
  }, [])

  React.useEffect(() => {
    if (blDetail && blDetail.poUpdateInprogress) {
      setShowWarningPOUpdate(true)
    }
  }, [blDetail])

  React.useEffect(() => {
    if (blDetail.id) {
      props.getBLGOAWorkFlowViewMode(blDetail.id)
    }
  }, [blDetail.id])

  // const showQr = () => {
  //   return haveTypeGoods(valueForm.billInvoices || []) && blDetail.status !== undefined && blDetail.status !== 0 && blDetail.status !== 3 && blDetail.status !== 4 && blDetail.status !== 6
  // }

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{blDetail.isSpecialCreditTerm && <Icon size='tiny' name='star' color='yellow' />}{`Billing - ${blDetail.documentNumber ? blDetail.documentNumber : 'Detail'}`}</React.Fragment>}
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <Button
            basic
            circular
            type='button'
            content='Print Billing Cover Page'
            labelPosition='right'
            icon='print'
            onClick={() => (window.open(billCoverPath(blDetail.id)))} />
        </div>
      }
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            { key: 'Billform', content: 'Billform ', link: true, onClick: () => history.push(billFormPath) },
            { key: 'BillformDetail', content: 'Detail', active: true }
          ]}
        />
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <DocumentStep documentDetail={blDetail} approvers={approvers} />
          <form >
            <RequestInformation reqInfo={blDetail} />
            {valueForm.sn ?
              <Approve handleSubmit={props.handleSubmit} history={history} blDetail={blDetail} /> : null
            }
            <Tab
              style={{ marginTop: '10px' }}
              menu={{ attached: false }}
              panes={[
                { menuItem: 'Bill Information', render: () => <BillInformation blDetail={blDetail} /> },
                { menuItem: 'Contract', render: () => <Contract blDetail={blDetail} /> },
                { menuItem: 'Attachment', render: () => <Attachment blDetail={blDetail} /> },
                { menuItem: 'Comment History', render: () => <CommentHistory blDetail={blDetail} history={history}/> },
              ]}
            />
          </form>
        </ProcurementBody>
      </ProcurementContainer>
      <Modal
        open={showWarningPOUpdate}
        header={<div className='header' style={{ color: '#FFCC00' }}>Warning!!</div>}
        closeOnDimmerClick={false}
        size='tiny'
        content={`Purchase Order(PO) No. ${blDetail.poUpdateSapNoList} has been created PO Update/Cancel . Please check documents related with the Purchase Order(PO).`}
        actions={[{ key: 'ok', content: 'OK', positive: true, onClick: () => setShowWarningPOUpdate(false) }]}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  let blDetail = state.billform.billformDetail.data
  let approvers = state.billform.approvers.data
  return ({
    blDetail,
    approvers: approvers,
    valueForm: getFormValues('formBill')(state) || {},
    initialValues: {
      ...blDetail,
      vendorCode: (blDetail.vendorCode || '').removeLeadingZero()
    },
  })
}

const mapDispatchToProps = {
  getBillformDetail,
  initializeBL,
  getBLGOAWorkFlowViewMode,
  clearBLDetail
}

const FormBillingDetail = reduxForm({
  form: 'formBill',
  enableReinitialize: true,
})(BillingDetail)

export default connect(mapStateToProps, mapDispatchToProps)(FormBillingDetail)
